import { GOAL_REAL_YIELD } from "web_myplann/Goals/constants";

export const calcPerpetualRentTotal = (monthly: number): number => {
	if (monthly <= 0) return 0;
	return Math.round((monthly * 12) / GOAL_REAL_YIELD);
};

export const calcRentToZeroTotal = (monthly: number, years: number): number => {
	if (monthly <= 0 || years <= 0) return 0;
	const monthlyRate = GOAL_REAL_YIELD / 12;
	const months = years * 12;
	const factor = (1 - (1 + monthlyRate) ** -months) / monthlyRate;
	return Math.round(monthly * factor);
};

export const calcPerpetualRentMonthly = (total: number): number => {
	if (total <= 0) return 0;
	return Math.round((total * GOAL_REAL_YIELD) / 12);
};

export const calcRentToZeroMonthly = (total: number, years: number): number => {
	if (total <= 0 || years <= 0) return 0;
	const monthlyRate = GOAL_REAL_YIELD / 12;
	const months = years * 12;
	const factor = (1 - (1 + monthlyRate) ** -months) / monthlyRate;
	return Math.round(total / factor);
};
